import { useState } from 'react';
import { CancelUploadAudioModal } from './components';
import { AudioFileProvider } from './context';
import UploadAudioModal from './UploadAudioModal';

interface PropsType {
  isOpen: boolean;
  onClose: () => void;
}

const UploadAudioModalContainer = ({ isOpen, onClose }: PropsType) => {
  const [isCancelUploadModalOpen, setIsCancelUploadModalOpen] = useState(false);

  const onConfirmCancelUploadAudio = () => {
    setIsCancelUploadModalOpen(false);
    onClose();
  };

  return (
    <AudioFileProvider>
      <UploadAudioModal
        isOpen={isOpen}
        onClose={onClose}
        onCancelUpload={() => setIsCancelUploadModalOpen(true)}
      />
      <CancelUploadAudioModal
        isOpen={isCancelUploadModalOpen}
        onClose={onConfirmCancelUploadAudio}
        onContinueUploadAudioFile={() => setIsCancelUploadModalOpen(false)}
      />
    </AudioFileProvider>
  );
};

export default UploadAudioModalContainer;
